import Api from '../Api';

class ContactApi extends Api {
  constructor() {
    super('contacts', 'contacts');
  }
}
const contactApi = new ContactApi();
export default contactApi;
